import gql from "graphql-tag";
import PostFields from "lib/graphql/fragments/engagement/PostFields";

export default gql`
  mutation EditPost($postId: ObjectID!, $bodyAsJson: JSON!, $bodyAsPlainText: String!, $title: String) {
    editPost(postId: $postId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText, title: $title) {
      ...PostFields
    }
  }

  ${PostFields}
`;
